import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import QRCode from 'qrcode';
import PaymentModal from './PaymentModal';

const QR_DATA = {
  "PayPal": "https://paypal.me/camiyeze",
  "Venmo": "venmo://paycharge?txn=pay&recipients=camilopz&amount=0&note=Regalo%20de%20Boda",
}

const Gifts = () => {
  const { t } = useLanguage();
  const [qrCodes, setQrCodes] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const paymentMethods = [
    // {
    //   id: 'zelle',
    //   name: 'Zelle',
    //   icon: 'fas fa-mobile-alt fa-2x',
    //   description: t('gifts.paymentMethods.zelle.description'),
    //   details: t('gifts.paymentMethods.zelle.details'),
    // },
    {
      id: 'venmo',
      name: 'Venmo',
      icon: 'fas fa-credit-card fa-2x',
      description: t('gifts.paymentMethods.venmo.description'),
      details: t('gifts.paymentMethods.venmo.details'),
      link: t('gifts.paymentMethods.venmo.link'),
    },
    {
      id: 'paypal',
      name: 'PayPal',
      icon: 'fab fa-paypal fa-2x',
      description: t('gifts.paymentMethods.paypal.description'),
      details: t('gifts.paymentMethods.paypal.details'),
      link: t('gifts.paymentMethods.paypal.link'),
    },
    {
      id: 'wireTransfer',
      name: t('gifts.paymentMethods.wireTransfer.name'),
      icon: 'fas fa-university fa-2x',
      description: t('gifts.paymentMethods.wireTransfer.description'),
      details: t('gifts.paymentMethods.wireTransfer.details'),
    },
    {
      id: 'wireTransferCol',
      name: t('gifts.paymentMethods.wireTransferCol.name'),
      icon: 'fas fa-university fa-2x',
      description: t('gifts.paymentMethods.wireTransferCol.description'),
      details: t('gifts.paymentMethods.wireTransferCol.details'),
    }
  ];

  // Generate QR codes for each payment method (except Zelle which uses static image)
  useEffect(() => {
    if (!qrCodes) {
      const generateQRCodes = async () => {
        const qrPromises = Object.keys(QR_DATA).map(async (key) => {
          try {
            const qrCodeDataURL = await QRCode.toDataURL(QR_DATA[key], {
              width: 120,
              margin: 2,
              color: {
                dark: '#000000',
                light: '#FFFFFF'
              }
            });
            return { [key]: qrCodeDataURL };
          } catch (error) {
            console.error(`Error generating QR code for ${key}:`, error);
            return { [key]: null };
          }
        });
  
        const qrResults = await Promise.all(qrPromises);
        const qrCodesObject = qrResults.reduce((acc, curr) => ({ ...acc, ...curr }), {});
        
        // Add Zelle static image
        // qrCodesObject["Zelle"] = "/images/zelle.png";
        
        setQrCodes(qrCodesObject);
      };
  
      generateQRCodes();
    }
    
  }, [paymentMethods]);

  const handlePaymentMethodClick = (method) => {
    setSelectedPaymentMethod(method);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedPaymentMethod(null);
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.6,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }
    }
  };

  return (
    <section id="gifts" className="pt-5">
      <div className="container">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="text-center mb-2"
        >
          <motion.h2 
            variants={itemVariants}
            className="section-title mb-4"
          >
            {t('gifts.title')}<div className="title-decoration"><img src="/images/section-title.png" alt="Decorative element" /></div>
          </motion.h2>

          <motion.p 
            variants={itemVariants}
            className="lead text-muted"
          >
            {t('gifts.subtitle')}
          </motion.p>
        </motion.div>

        

          {/* Right Side - QR Codes Section */}
          <motion.div 
            variants={itemVariants}
            className="qr-codes-column"
          >
            <div className="gifts-unified-section">
              <div className="gifts-content">
                <div className="payment-methods-grid">
                  {paymentMethods.map((method, index) => {
                    return (
                      <motion.div
                        key={method.id}
                        variants={itemVariants}
                        className="payment-method-item payment-method-card"
                        onClick={() => handlePaymentMethodClick(method)}
                      >
                        <div className="payment-method-icon">
                          <i className={`${method.icon}`}></i>
                        </div>
                        <div className="payment-method-info">
                          <h6 className="payment-method-name">{method.name}</h6>
                          <p className="payment-method-description">{method.description}</p>
                          <small className="payment-method-click-hint">{t('gifts.clickForDetails')}</small>
                        </div>
                      </motion.div>
                    )
                  })}
                </div>
              </div>
            </div>
          </motion.div>

        {/* Payment Modal */}
        <PaymentModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          paymentMethod={selectedPaymentMethod}
          qrCode={selectedPaymentMethod && qrCodes ? qrCodes[selectedPaymentMethod.name] : null}
        />
      </div>
    </section>
  );
};

export default Gifts;
